import { PageWizardProps } from '.';
import BlockNavigation from '../../../components/BlockNavigation';
import { ROUTES } from '../../../routes/routes';
import { CustomProduct, PricingPage, Product } from '../../../types/pricingPage';
import Footer from './Footer';
import ProductChooser from './ProductChooser';

interface Props extends PageWizardProps {
    onReloadProducts: () => void;
    onChangeSelectedProducts: (selectedProducts: Product[]) => void;
    onAddCustomProduct: (product: CustomProduct) => void;
    onDeleteCustomProduct: (product: CustomProduct) => void;
    onChangeMode: (status: PricingPage['status']) => void;
}

export default function ChooseProducts({
    allProducts,
    selectedProducts,
    page,
    onReloadProducts,
    onChangeSelectedProducts,
    onAddCustomProduct,
    onDeleteCustomProduct,
    onChangeMode,
}: Props) {
    const handleSelectProduct = (product: Product) => {
        onChangeSelectedProducts([...selectedProducts, product]);
    };
    const handleRemoveProduct = (productToRemove: Product) => {
        onChangeSelectedProducts(selectedProducts.filter((product) => product.id !== productToRemove.id));
    };
    const handleAddProduct = (productToAdd: CustomProduct) => {
        onAddCustomProduct(productToAdd);
        onChangeSelectedProducts([...selectedProducts, productToAdd]);
    };
    const handleDeleteCustomProduct = (productToDelete: CustomProduct) => {
        onDeleteCustomProduct(productToDelete);
        onChangeSelectedProducts(selectedProducts.filter((product) => product.id !== productToDelete.id));
    };

    const ready = !!page.name && selectedProducts.length > 0;

    return (
        <>
            <ProductChooser
                page={page}
                allProducts={allProducts}
                selectedProducts={selectedProducts}
                onSelectProduct={handleSelectProduct}
                onRemoveProduct={handleRemoveProduct}
                onReloadProducts={onReloadProducts}
                onAddProduct={handleAddProduct}
                onDeleteProduct={handleDeleteCustomProduct}
                onChangeSelectedProducts={onChangeSelectedProducts}
                onChangeMode={onChangeMode}
            />
            <Footer
                error={!page.name ? 'Give your page a name' : undefined}
                next={{ href: ROUTES.PAGES_NEW_FLOW, disabled: !ready }}
                item={page}
            />
            <BlockNavigation when={!ready} />
        </>
    );
}
